import { isEqual, differenceWith, isEmpty } from "lodash";

// compare two array of objects for equality
// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'x' implicitly has an 'any' type.
export const areArraysEqual = (x, y) => {
  if (!Array.isArray(x) || !Array.isArray(y)) {
    return false;
  }
  if (x.length !== y.length) {
    return false;
  }
  return isEmpty(differenceWith(x, y, isEqual));
};

type ArrayWithMore<T> = [...T[], string];

export function ellipsisArrayContent<P>(
  data: P[],
  arrayLengthToReturn = 3
): P[] | ArrayWithMore<P> {
  if (data.length <= arrayLengthToReturn) {
    return data;
  }
  // Cannot use `.concat` because of typescript complaining on altering the return type to use `Array<P | ConcatArray<P>>`
  return [
    ...data.slice(0, arrayLengthToReturn - 1),
    `+ ${data.slice(arrayLengthToReturn - 1).length} more`,
  ];
}
